module.exports = __webpack_public_path__ + "img/Weapon_241.e6857da8.png";